import { cva } from 'class-variance-authority';

export const LinkStyles = cva(['flex', 'h-10', 'w-10', 'items-center', 'justify-center', 'bg-gray-900'], {
  variants: {
    disabled: {
      true: ['bg-gray-200', 'text-gray-400', 'cursor-not-allowed', 'pointer-events-none', 'opacity-20'],
    },
  },
});
